var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearchBlock = function SvgSearchBlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#F8F8F8",
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3C3C3C",
    fillRule: "nonzero",
    d: "m27.796 26.908-3.498-3.52a6.962 6.962 0 0 0 1.568-4.413c0-3.845-3.11-6.975-6.933-6.975S12 15.128 12 18.975c0 3.847 3.11 6.976 6.933 6.976a6.87 6.87 0 0 0 4.385-1.578l3.499 3.52a.689.689 0 0 0 .49.204.689.689 0 0 0 .491-.204.7.7 0 0 0-.002-.985zm-14.41-7.933c0-3.076 2.49-5.58 5.547-5.58 3.057 0 5.546 2.504 5.546 5.58 0 3.077-2.489 5.58-5.546 5.58-3.058 0-5.546-2.503-5.546-5.58z"
  }))));
};
export default SvgSearchBlock;